import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthContext from "./AuthContext/AuthContext";
import "../src/assets/vendors/bootstrap/css/bootstrap.min.css";
import "../src/assets/vendors/icofont/icofont.min.css";
import "../src/assets/vendors/jarallax/jarallax.css";
import "../src/assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css";
import "../src/assets/vendors/jquery-ui/jquery-ui.css";
import "../src/assets/vendors/nouislider/nouislider.min.css";
import "../src/assets/vendors/nouislider/nouislider.pips.css";
import "../src/assets/vendors/owl-carousel/css/owl.carousel.min.css";
import "../src/assets/vendors/owl-carousel/css/owl.theme.default.min.css";
import "../src/assets/vendors/slick/slick.css";
import "../src/assets/vendors/tiny-slider/tiny-slider.css";
import "../src/assets/vendors/fontawesome/css/all.min.css";
import "../src/assets/vendors/careox-toolbar/css/careox-toolbar.css";
import "../src/assets/vendors/careox-icons/style.css";
import "../src/assets/vendors/bootstrap-select/bootstrap-select.min.css";
import "../src/assets/vendors/animate/animate.min.css";
import "../src/assets/css/careox.css";
import { Toaster } from "react-hot-toast";
import "./i18n";
import "bootstrap-icons/font/bootstrap-icons.css";
import $ from "jquery";
window.jQuery = $;
window.$ = $;


// ✅ Load Razorpay once globally
const loadRazorpay = () => {
  if (!document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    console.log("✅ Razorpay script loaded");
  }
};

// ✅ Root component wrapper
const Root = () => {
  useEffect(() => {
    loadRazorpay(); // Load Razorpay SDK globally
  }, []);

  return (
    <AuthContext>
      <Toaster />
      <App />
    </AuthContext>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

reportWebVitals();
